import React from 'react';
import { Button } from '../../buttons/Button';
import { LabeledElement } from '../../labels/LabeledElement';
import { Input } from '../Input';
import styles from './styles.module.scss';

export const ActionInput = ({ 
  description,
  descriptionPosition = 'bottom',
  id, 
  className, 
  hasError, disabled, labelIntl, actionLabel, ...props }) => (
    <div className={styles.actionInputWrapper}>
      <LabeledElement
        label={labelIntl}
        description={description}
        descriptionPosition={descriptionPosition}
        id={id}
        className={styles.labeledInput}
      >
        <div className={styles.actionInput}>
          <Input
            className={className}
            hasError={hasError}
            disabled={disabled}
            {...props}
          />
          <Button
            basic
            color="primary"
          >{actionLabel}
          </Button>
        </div>
      </LabeledElement>

    </div>
);
